<template>
  <form-wrapper>
    <b-form @submit="onSubmit">
      <h2 class="text-center">
        Update Knowledge Check
      </h2>

      <b-form-group>
        <label for="instructions">Instructions</label>
        <wysiwyg :class="{ 'disabled' : saving }" v-model="innerModel.instructions"/>
      </b-form-group>
      <b-form-group>
        <label for="questions">Number of Questions</label>
        <div class="text-muted">Select the number of questions that will be chosen from the question bank for each knowledge check</div>
        <b-form-input
          v-validate="'required'"
          id="questions"
          :disabled="saving"
          v-model="innerModel.number_questions"
          class="col-sm-2"
          type="number"
          name="questions"
        />
      </b-form-group>
    </b-form>

    <b-form-group class="form-buttons">
      <b-button :disabled="disabled" type="submit" variant="primary" @click.stop="onSubmit">
        Update
        <span v-if="saving">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
      </b-button>
    </b-form-group>
  </form-wrapper>
</template>

<script>
import api from '@/api/knowledgechecks/knowledgecheck.js'
import { mapActions, mapState } from 'vuex'
import formWrapper from '@/components/common/form/form-wrapper'

export default {
  components:{
    formWrapper
  },
  props:{
    value: {type:Object, default:null}
  },
  data(){
    return {
      innerModel: {},
      saving: false,
      fetching: false
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('components', {
      component: 'current'
    }),
    disabled(){
      return this.fetching || this.saving
    }
  },
  watch: {
    value(val){
      if(val != this.innerModel){
        this.innerModel = val
      }
    }
  },
  methods:{
    ...mapActions('components', {
      refresh: 'show'
    }),
    async onSubmit(){
      const payload = {
        tenantId: this.organization.id,
        knowledgecheckId: this.innerModel.id,
        data: this.innerModel
      }

      this.saving = true
      await api.update(payload)
      await this.refresh({id:this.component.id})
      this.saving = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/components/edit.vue